import { useState } from 'react'
import { useCreateReview } from '@/hooks/useReviews'
import { useQueryClient } from '@tanstack/react-query'
import Button from '@/components/common/Button/Button'
import './ReviewModal.css'

interface ReviewModalProps {
    serviceRequestId: number
    serviceName: string
    providerName: string
    handleClose: () => void
}

const ReviewModal = ({ serviceRequestId, serviceName, providerName, handleClose }: ReviewModalProps) => {
    const [rating, setRating] = useState(5)
    const [comment, setComment] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const queryClient = useQueryClient()
    
    const createReview = useCreateReview()

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setIsSubmitting(true)
        
        try {
            await createReview.mutateAsync({
                service_request: serviceRequestId,
                rating,
                comment
            })
            // Invalidate queries to refresh data
            queryClient.invalidateQueries({ queryKey: ['service-requests'] })
            queryClient.invalidateQueries({ queryKey: ['service-request', serviceRequestId] })
            handleClose()
        } catch (error) {
            console.error('Error creating review:', error)
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <div className="review-modal">
            <div className="review-modal_content">
                <h2 className="review-modal_title">Calificar Servicio</h2>
                <p className="review-modal_service">{serviceName}</p>
                <p className="review-modal_provider">Proveedor: {providerName}</p>
                
                <form onSubmit={handleSubmit} className="review-modal_form">
                    <div className="review-modal_rating">
                        <label>Calificación:</label>
                        <div className="review-modal_stars">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <button
                                    key={star}
                                    type="button"
                                    className={`review-modal_star ${star <= rating ? 'active' : ''}`}
                                    onClick={() => setRating(star)}
                                >
                                    ★
                                </button>
                            ))}
                        </div>
                    </div>
                    
                    <div className="review-modal_comment">
                        <label htmlFor="comment">Comentario (opcional):</label>
                        <textarea
                            id="comment"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="¿Cómo fue tu experiencia?"
                            rows={4}
                        />
                    </div>
                    
                    <div className="review-modal_actions">
                        <Button
                            type="button"
                            variant="secondary"
                            onClick={handleClose}
                            disabled={isSubmitting}
                        >
                            Cancelar
                        </Button>
                        <Button
                            type="submit"
                            variant="primary"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Enviando...' : 'Enviar Calificación'}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ReviewModal
